import Lottie from 'lottie-react'
import React from 'react'
import loadingIcon from"../../assets/Sandy Loading.json"

export const GlobalLoading = () => {

  return (
    <div className='w-full h-screen flex flex-col items-center justify-center fixed inset-0 z-[9999]  bg-white/80 backdrop-blur-sm '>
         <Lottie
            animationData={loadingIcon}
            loop
            autoplay
            style={{ width: 800, height: 800 }}
          />
          <h1 className="text-5xl font-bold text-gray-600">Please wait, We're working on it</h1>
         
    </div>
  )
}
